'use strict';

var _regeneratorRuntime = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _classCallCheck = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var SparseArray = require('sparse-array');

var wrapHash = require('./consumable-hash');

var defaultOptions = {
  bits: 8
};

var Bucket =
/*#__PURE__*/
function () {
  function Bucket(options, parent, posAtParent) {
    _classCallCheck(this, Bucket);

    this._options = Object.assign({}, defaultOptions, options);
    this._popCount = 0;
    this._parent = parent;
    this._posAtParent = posAtParent;

    if (!this._options.hashFn) {
      throw new Error('please define an options.hashFn');
    } // make sure we only wrap options.hashFn once in the whole tree


    if (!this._options.hash) {
      this._options.hash = wrapHash(this._options.hashFn);
    }

    this._children = new SparseArray();
  }

  _createClass(Bucket, [{
    key: "put",
    value: function put(key, value) {
      var place;
      return _regeneratorRuntime.async(function put$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _regeneratorRuntime.awrap(this._findNewBucketAndPos(key));

            case 2:
              place = _context.sent;
              _context.next = 5;
              return _regeneratorRuntime.awrap(place.bucket._putAt(place, key, value));

            case 5:
            case "end":
              return _context.stop();
          }
        }
      }, null, this);
    }
  }, {
    key: "get",
    value: function get(key) {
      var child;
      return _regeneratorRuntime.async(function get$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return _regeneratorRuntime.awrap(this._findChild(key));

            case 2:
              child = _context2.sent;

              if (!child) {
                _context2.next = 5;
                break;
              }

              return _context2.abrupt("return", child.value);

            case 5:
            case "end":
              return _context2.stop();
          }
        }
      }, null, this);
    }
  }, {
    key: "del",
    value: function del(key) {
      var place, child;
      return _regeneratorRuntime.async(function del$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return _regeneratorRuntime.awrap(this._findPlace(key));

            case 2:
              place = _context3.sent;
              child = place.bucket._at(place.pos);

              if (child && child.key === key) {
                place.bucket._delAt(place.pos);
              }

            case 5:
            case "end":
              return _context3.stop();
          }
        }
      }, null, this);
    }
  }, {
    key: "leafCount",
    value: function leafCount() {
      return this._children.compactArray().reduce(function (acc, child) {
        if (child instanceof Bucket) {
          return acc + child.leafCount();
        }

        return acc + 1;
      }, 0);
    }
  }, {
    key: "childrenCount",
    value: function childrenCount() {
      return this._children.length;
    }
  }, {
    key: "onlyChild",
    value: function onlyChild() {
      return this._children.get(0);
    }
  }, {
    key: "eachLeafSeries",
    value:
    /*#__PURE__*/
    _regeneratorRuntime.mark(function eachLeafSeries() {
      var children, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, child, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, c2;

      return _regeneratorRuntime.wrap(function eachLeafSeries$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              children = this._children.compactArray();
              _iteratorNormalCompletion = true;
              _didIteratorError = false;
              _iteratorError = undefined;
              _context4.prev = 4;
              _iterator = children[Symbol.iterator]();

            case 6:
              if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
                _context4.next = 42;
                break;
              }

              child = _step.value;

              if (!(child instanceof Bucket)) {
                _context4.next = 37;
                break;
              }

              _iteratorNormalCompletion2 = true;
              _didIteratorError2 = false;
              _iteratorError2 = undefined;
              _context4.prev = 12;
              _iterator2 = child.eachLeafSeries()[Symbol.iterator]();

            case 14:
              if (_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done) {
                _context4.next = 21;
                break;
              }

              c2 = _step2.value;
              _context4.next = 18;
              return c2;

            case 18:
              _iteratorNormalCompletion2 = true;
              _context4.next = 14;
              break;

            case 21:
              _context4.next = 27;
              break;

            case 23:
              _context4.prev = 23;
              _context4.t0 = _context4["catch"](12);
              _didIteratorError2 = true;
              _iteratorError2 = _context4.t0;

            case 27:
              _context4.prev = 27;
              _context4.prev = 28;

              if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                _iterator2.return();
              }

            case 30:
              _context4.prev = 30;

              if (!_didIteratorError2) {
                _context4.next = 33;
                break;
              }

              throw _iteratorError2;

            case 33:
              return _context4.finish(30);

            case 34:
              return _context4.finish(27);

            case 35:
              _context4.next = 39;
              break;

            case 37:
              _context4.next = 39;
              return child;

            case 39:
              _iteratorNormalCompletion = true;
              _context4.next = 6;
              break;

            case 42:
              _context4.next = 48;
              break;

            case 44:
              _context4.prev = 44;
              _context4.t1 = _context4["catch"](4);
              _didIteratorError = true;
              _iteratorError = _context4.t1;

            case 48:
              _context4.prev = 48;
              _context4.prev = 49;

              if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
              }

            case 51:
              _context4.prev = 51;

              if (!_didIteratorError) {
                _context4.next = 54;
                break;
              }

              throw _iteratorError;

            case 54:
              return _context4.finish(51);

            case 55:
              return _context4.finish(48);

            case 56:
            case "end":
              return _context4.stop();
          }
        }
      }, eachLeafSeries, this, [[4, 44, 48, 56], [12, 23, 27, 35], [28,, 30, 34], [49,, 51, 55]]);
    })
  }, {
    key: "serialize",
    value: function serialize(map, reduce) {
      // serialize to a custom non-sparse representation
      return reduce(this._children.reduce(function (acc, child, index) {
        if (child) {
          if (child instanceof Bucket) {
            acc.push(child.serialize(map, reduce));
          } else {
            acc.push(map(child, index));
          }
        }

        return acc;
      }, []));
    }
  }, {
    key: "asyncTransform",
    value: function asyncTransform(asyncMap, asyncReduce) {
      return _regeneratorRuntime.async(function asyncTransform$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              return _context5.abrupt("return", asyncTransformBucket(this, asyncMap, asyncReduce));

            case 1:
            case "end":
              return _context5.stop();
          }
        }
      }, null, this);
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      return this.serialize(mapNode, reduceNodes);
    }
  }, {
    key: "prettyPrint",
    value: function prettyPrint() {
      return JSON.stringify(this.toJSON(), null, '  ');
    }
  }, {
    key: "tableSize",
    value: function tableSize() {
      return Math.pow(2, this._options.bits);
    }
  }, {
    key: "_findChild",
    value: function _findChild(key) {
      var result, child;
      return _regeneratorRuntime.async(function _findChild$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              _context6.next = 2;
              return _regeneratorRuntime.awrap(this._findPlace(key));

            case 2:
              result = _context6.sent;
              child = result.bucket._at(result.pos);

              if (!(child && child.key === key)) {
                _context6.next = 6;
                break;
              }

              return _context6.abrupt("return", child);

            case 6:
            case "end":
              return _context6.stop();
          }
        }
      }, null, this);
    }
  }, {
    key: "_findPlace",
    value: function _findPlace(key) {
      var hashValue, index, child;
      return _regeneratorRuntime.async(function _findPlace$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              hashValue = this._options.hash(key);
              _context7.next = 3;
              return _regeneratorRuntime.awrap(hashValue.take(this._options.bits));

            case 3:
              index = _context7.sent;
              child = this._children.get(index);

              if (!(child instanceof Bucket)) {
                _context7.next = 7;
                break;
              }

              return _context7.abrupt("return", child._findPlace(hashValue));

            case 7:
              return _context7.abrupt("return", {
                bucket: this,
                pos: index,
                hash: hashValue
              });

            case 8:
            case "end":
              return _context7.stop();
          }
        }
      }, null, this);
    }
  }, {
    key: "_findNewBucketAndPos",
    value: function _findNewBucketAndPos(key) {
      var place, child, bucket, newPlace;
      return _regeneratorRuntime.async(function _findNewBucketAndPos$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              _context8.next = 2;
              return _regeneratorRuntime.awrap(this._findPlace(key));

            case 2:
              place = _context8.sent;
              child = place.bucket._at(place.pos);

              if (!(child && child.key !== key)) {
                _context8.next = 12;
                break;
              }

              // conflict
              bucket = new Bucket(this._options, place.bucket, place.pos);

              place.bucket._putObjectAt(place.pos, bucket); // put the previous value


              _context8.next = 9;
              return _regeneratorRuntime.awrap(bucket._findPlace(child.hash));

            case 9:
              newPlace = _context8.sent;

              newPlace.bucket._putAt(newPlace, child.key, child.value);

              return _context8.abrupt("return", bucket._findNewBucketAndPos(place.hash));

            case 12:
              return _context8.abrupt("return", place);

            case 13:
            case "end":
              return _context8.stop();
          }
        }
      }, null, this);
    }
  }, {
    key: "_putAt",
    value: function _putAt(place, key, value) {
      this._putObjectAt(place.pos, {
        key: key,
        value: value,
        hash: place.hash
      });
    }
  }, {
    key: "_putObjectAt",
    value: function _putObjectAt(pos, object) {
      if (!this._children.get(pos)) {
        this._popCount++;
      }

      this._children.set(pos, object);
    }
  }, {
    key: "_delAt",
    value: function _delAt(pos) {
      if (this._children.get(pos)) {
        this._popCount--;
      }

      this._children.unset(pos);

      this._level();
    }
  }, {
    key: "_level",
    value: function _level() {
      if (this._parent && this._popCount <= 1) {
        if (this._popCount === 1) {
          // remove myself from parent, replacing me with my only child
          var onlyChild = this._children.find(exists);

          if (!(onlyChild instanceof Bucket)) {
            var hash = onlyChild.hash;
            hash.untake(this._options.bits);
            var place = {
              pos: this._posAtParent,
              hash: hash
            };

            this._parent._putAt(place, onlyChild.key, onlyChild.value);
          }
        } else {
          this._parent._delAt(this._posAtParent);
        }
      }
    }
  }, {
    key: "_at",
    value: function _at(index) {
      return this._children.get(index);
    }
  }], [{
    key: "isBucket",
    value: function isBucket(o) {
      return o instanceof Bucket;
    }
  }]);

  return Bucket;
}();

function exists(o) {
  return Boolean(o);
}

function mapNode(node, index) {
  return node.key;
}

function reduceNodes(nodes) {
  return nodes;
}

function asyncTransformBucket(bucket, asyncMap, asyncReduce) {
  var output, _iteratorNormalCompletion3, _didIteratorError3, _iteratorError3, _iterator3, _step3, child, mappedChildren;

  return _regeneratorRuntime.async(function asyncTransformBucket$(_context9) {
    while (1) {
      switch (_context9.prev = _context9.next) {
        case 0:
          output = [];
          _iteratorNormalCompletion3 = true;
          _didIteratorError3 = false;
          _iteratorError3 = undefined;
          _context9.prev = 4;
          _iterator3 = bucket._children.compactArray()[Symbol.iterator]();

        case 6:
          if (_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done) {
            _context9.next = 21;
            break;
          }

          child = _step3.value;

          if (!(child instanceof Bucket)) {
            _context9.next = 13;
            break;
          }

          _context9.next = 11;
          return _regeneratorRuntime.awrap(asyncTransformBucket(child, asyncMap, asyncReduce));

        case 11:
          _context9.next = 17;
          break;

        case 13:
          _context9.next = 15;
          return _regeneratorRuntime.awrap(asyncMap(child));

        case 15:
          mappedChildren = _context9.sent;
          output.push({
            bitField: bucket._children.bitField(),
            children: mappedChildren
          });

        case 17:
          return _context9.abrupt("return", asyncReduce(output));

        case 18:
          _iteratorNormalCompletion3 = true;
          _context9.next = 6;
          break;

        case 21:
          _context9.next = 27;
          break;

        case 23:
          _context9.prev = 23;
          _context9.t0 = _context9["catch"](4);
          _didIteratorError3 = true;
          _iteratorError3 = _context9.t0;

        case 27:
          _context9.prev = 27;
          _context9.prev = 28;

          if (!_iteratorNormalCompletion3 && _iterator3.return != null) {
            _iterator3.return();
          }

        case 30:
          _context9.prev = 30;

          if (!_didIteratorError3) {
            _context9.next = 33;
            break;
          }

          throw _iteratorError3;

        case 33:
          return _context9.finish(30);

        case 34:
          return _context9.finish(27);

        case 35:
        case "end":
          return _context9.stop();
      }
    }
  }, null, null, [[4, 23, 27, 35], [28,, 30, 34]]);
}

module.exports = Bucket;